import { SettingsTranslationType } from "../../features/settings.types";

export const settings: SettingsTranslationType = {
  settings: {
    title: "Paramètres",
    aiProvider: {
      label: "Fournisseur d'IA",
      select: "Sélectionner un fournisseur",
      description: "Choisissez le fournisseur d'IA à utiliser pour la génération d'histoires",
      updateSuccess: "Fournisseur d'IA Mis à Jour",
      updateSuccessDesc: "Votre préférence de fournisseur d'IA a été enregistrée",
      updateError: "Échec de la Mise à Jour",
      updateErrorDesc: "Échec de la mise à jour du fournisseur d'IA. Veuillez réessayer."
    },
    language: {
      label: "Langue",
      description: "Choisissez votre langue d'interface préférée"
    },
    subscription: {
      title: "Abonnement",
      currentPlan: "Plan Actuel",
      freeTier: "Gratuit",
      basicTier: "Basique",
      premiumTier: "Premium",
      status: "Statut",
      renewalDate: "Date de Renouvellement",
      upgradePlan: "Améliorer le Plan",
      managePlan: "Gérer l'Abonnement",
      cancelPlan: "Annuler l'Abonnement",
      features: "Fonctionnalités",
      billingCycle: "Cycle de Facturation",
      monthlyLabel: "Mensuel",
      yearlyLabel: "Annuel",
      priceUnits: {
        month: "mois",
        year: "an"
      },
      tiers: {
        free: {
          name: "Gratuit",
          description: "Fonctionnalités de base pour commencer",
          price: "Gratuit"
        },
        basic: {
          name: "Basique",
          description: "Fonctionnalités avancées pour les écrivains amateurs",
          price: {
            monthly: "9,99€/mois",
            yearly: "99€/an"
          }
        },
        premium: {
          name: "Premium",
          description: "Accès complet pour les écrivains professionnels",
          price: {
            monthly: "19,99€/mois",
            yearly: "199€/an"
          }
        }
      },
      browseCharacters: "Parcourir les Personnages",
      upgradeToBrowse: "Mettez à niveau pour parcourir votre collection de personnages",
      upgradeToMakePublic: "Mettez à niveau pour rendre les personnages publics",
      upgradeRequired: "Mise à Niveau Requise",
      upgradeToBrowseDescription: "Mettez à niveau votre compte pour parcourir et réutiliser votre collection de personnages.",
      upgradeToMakePublicDescription: "Mettez à niveau votre compte pour partager publiquement des personnages avec d'autres utilisateurs.",
      unlockFeatures: "Débloquez des fonctionnalités premium avec un abonnement",
      upgradeNow: "Mettre à Niveau Maintenant",
      unlockAiTitleGeneration: "Débloquer la Génération de Titres par IA",
      upgradeForCharaterAccess: "Mise à Niveau pour Accéder à la Gestion des Personnages",
      upgradeForStatsAccess: "Mise à Niveau pour Accéder aux Statistiques et Badges",
      upgradeForAccess: "Mise à Niveau pour Accéder à cette fonctionnalité",
      upgradeForAiTitleDescription: "Passez au plan Basique pour accéder à la génération de titres par IA et obtenir des suggestions créatives basées sur les thèmes, les personnages et les décors de votre histoire.",
      generateTitlesFeature: "Générez des titres uniques instantanément",
      aiTitleGenerationPremium: "La Génération de Titres par IA est disponible dans le plan Basique",
      unlockGenre: "Mettez à niveau pour débloquer ce genre",
      unlockCustomGenres: "Débloquer les Genres Personnalisés",
      upgradeForCustomGenresDescription: "Passez au plan Basique pour créer des genres personnalisés et rendre vos histoires plus uniques.",
      addCustomGenresFeature: "Ajoutez des genres personnalisés illimités",
      unlockEnvironment: "Mettez à niveau pour débloquer cet environnement",
      upgradeForCustomEnvironments: "Passez à TaleCraft Basique pour ajouter des environnements personnalisés",
      unlockCustomEnvironments: "Débloquer les Environnements Personnalisés",
      upgradeForCustomEnvironmentsDescription: "Passez au plan Basique pour créer des environnements personnalisés et rendre vos histoires plus uniques.",
      addCustomEnvironmentsFeature: "Ajoutez des environnements personnalisés illimités",
      unlockTheme: "Mettez à niveau pour débloquer ce thème",
      upgradeForCustomThemes: "Passez à TaleCraft Basique pour ajouter des thèmes personnalisés",
      unlockCustomThemes: "Débloquer les Thèmes Personnalisés",
      upgradeForCustomThemesDescription: "Passez au plan Basique pour créer des thèmes personnalisés et rendre vos histoires plus uniques.",
      addCustomThemesFeature: "Ajoutez des thèmes personnalisés illimités",
      unlockStoryLength: "Mettez à niveau pour débloquer cette longueur d'histoire",
      upgradeForPremiumLengths: "Passez à TaleCraft Basique pour accéder à des histoires plus longues",
      unlockPremiumLengths: "Débloquer les Longueurs d'Histoire Premium",
      upgradeForPremiumLengthsDescription: "Passez au plan Premium pour créer des histoires plus longues et développer vos récits avec plus de détails.",
      longStoriesFeature: "Créez des histoires sans restrictions de longueur",
      avatarGenerator: {
        upgradeRequired: "Mise à Niveau Requise",
        upgradeDescription: "Mettez à niveau votre compte pour générer des avatars de personnages.",
        premiumFeature: "Générez des avatars de personnages personnalisés avec un abonnement premium",
        upgradeNow: "Mettre à Niveau Maintenant",
        upgradeTooltip: "Mettez à niveau pour générer des avatars de personnages"
      },
      planComparison: {
        chooseYourPlan: "Choisissez le plan qui correspond le mieux à vos besoins",
        price: "Prix",
        features: "Fonctionnalités",
        talecraftBasic: "TaleCraft Basique",
        talecraftPremium: "TaleCraft Premium",
        savePercentage: "Économisez 17%",
        currentPlanLabel: "Plan Actuel:",
        processing: "Traitement en cours...",
        downgradeToBasic: "Rétrograder vers TaleCraft Basique",
        downgradeToFree: "Rétrograder vers le Plan Gratuit",
        upgradeToBasic: "Passer à TaleCraft Basique",
        upgradeToPremium: "Passer à TaleCraft Premium",
        downgradingTo: "Rétrogradation vers",
        effectiveOn: "Effectif le",
        nextBillingDate: "Date de Prochaine Facturation",
        featureItems: {
          dailyStoryLimit: "Limite d'histoires quotidiennes",
          aiStoryGeneration: "Génération d'histoires par IA",
          customResponses: "Réponses personnalisées",
          aiTitleSuggestion: "Suggestion de titres par IA",
          customStorySelection: "Sélection d'histoires personnalisées",
          publicSharing: "Partage public",
          characterManagement: "Gestion des personnages",
          aiProviderSelection: "Sélection du fournisseur d'IA",
          statsAndBadges: "Statistiques et badges/classement",
          badgeRewards: "Récompenses de badges",
          naturalStoryLength: "Longueur naturelle de l'histoire",
          sequelsAndExtract: "Suites et extraction de personnages",
          characterAvatar: "Avatar de personnage",
          earlyAccessFeatures: "Fonctionnalités en accès anticipé"
        },
        limits: {
          perDay: "/jour",
          unlimited: "Illimité"
        }
      }
    },
    profile: {
      displayName: {
        label: "Nom d'Affichage",
        placeholder: "Entrez votre nom d'affichage",
        updateButton: "Mettre à Jour le Nom",
        helpText: "Choisissez un nom d'affichage unique pour votre profil"
      },
      inviteFriends: {
        label: "Inviter des Amis",
        button: "Inviter des Amis",
        dialogTitle: "Partager l'Invitation",
        dialogDescription: "Invitez vos amis à vous rejoindre dans votre aventure narrative. Partagez votre lien d'invitation unique ou utilisez les réseaux sociaux.",
        copySuccess: {
          title: "Lien copié !",
          description: "Le lien de parrainage a été copié dans votre presse-papiers."
        },
        copyFailure: {
          title: "Échec de la copie",
          description: "Veuillez essayer de copier le lien manuellement."
        },
        shareMessage: "Rejoignez-moi dans notre aventure narrative ! Créez et partagez des histoires étonnantes ensemble.",
        socialPlatforms: {
          facebook: "Facebook",
          X: "X",
          linkedin: "LinkedIn",
        }
      },
      upgradeDialog: {
        title: "Mise à Niveau Requise",
        aiProviderDescription: "Passez à la version supérieure pour sélectionner un fournisseur d'IA.",
        unlockProviderSelection: "Débloquez la sélection du fournisseur d'IA avec un abonnement"
      }
    },
    issues: {
      title: "Signaler un problème",
      description: "Vous avez trouvé un bug ou avez une suggestion ? Faites-le nous savoir !",
      submitSuccess: "Problème signalé",
      submitSuccessDesc: "Merci pour votre retour. Nous examinerons le problème.",
      submitError: "Échec de l'envoi",
      submitErrorDesc: "Un problème est survenu lors du signalement. Veuillez réessayer plus tard.",
      form: {
        titleLabel: "Titre",
        titlePlaceholder: "Brève description du problème",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Veuillez fournir des détails sur le problème...",
        priorityLabel: "Priorité",
        priorityPlaceholder: "Sélectionner la priorité",
        priorityLow: "Basse",
        priorityMedium: "Moyenne",
        priorityHigh: "Haute",
        priorityDescription: "Sélectionnez l'urgence de ce problème pour nous aider à le prioriser correctement.",
        submit: "Soumettre le problème",
        submitting: "Soumission en cours...",
        imagesLabel: "Joindre des Images (Facultatif)",
        typeLabel: "Type de problème",
        typePlaceholder: "Sélectionner le type de problème",
        typeBug: "Bug",
        typeRequest: "Demande",
        typeDescription: "Sélectionnez le type de problème que vous signalez",
      },
      imageUpload: {
        dragDrop: "Glisser-déposer les images ici",
        dropHere: "Déposez les images ici...",
        clickToSelect: "ou cliquez pour sélectionner des fichiers",
        maxSize: "Max 5 Mo par fichier",
        maxNumber: "Max 5 images",
        attachedImages: "Images jointes",
        invalidFiles: "Certains fichiers n'ont pas été acceptés",
        sizeTypeLimit: "Les fichiers doivent être des images de moins de 5 Mo",
        tooManyImages: "Nombre d'images jointes trop élevé",
        limitReached: "Vous ne pouvez joindre que jusqu'à 5 images",
        pasteSupported: "Support du collage d'images",
        pasteSuccess: "Image collée",
        pasteSuccessDesc: "Image du presse-papiers jointe",
        pasteFailed: "Échec du collage de l'image",
        pasteFailedDesc: "Impossible de traiter le contenu du presse-papiers",
        processing: "Traitement de l'image...",
      },
    }
  }
};
